import { TuiIconTdsServiceChevronLeft } from '@tui-react/proprietary-icons';
import cn from 'classnames';
import React from 'react';
import intl from '../../../../../locale';
import styles from './BackButton.module.css';

interface BackButtonProps {
  onClick: VoidFunction;
  className?: string;
}

export const BackButton = ({ className, onClick }: BackButtonProps) => {
  return (
    <button className={cn(styles.button, className)} onClick={onClick}>
      <span className={styles.icon}>
        <TuiIconTdsServiceChevronLeft iconSize="var(--icon-xs)" style={{ color: 'var(--tui-text-tertiary)' }} />
      </span>

      {intl.formatMessage({ id: 'System.Back' })}
    </button>
  );
};
